import styled from 'styled-components';
import { FormGroup, Panel, RadioGroup, Row } from 'rsuite';

export const StyledFormGroup = styled(FormGroup)`
  vertical-align: top;
  display: inline-block !important;
  margin-right: 15px !important;

  .rs-control-label {
    text-transform: none;
  }
  .rs-form-control-wrapper {
    margin-left: 0 !important;
  }
  .rs-picker-daterange.rs-picker-cleanable .rs-picker-toggle,
  .rs-picker-cleanable .rs-picker-toggle {
    padding-right: 38px;
  }
  .rs-picker-value-count {
    padding: 0 7px;
  }
  .rs-picker-toggle-caret {
    right: 8px;
  }
  .rs-picker-toggle-clean {
    right: 28px !important;
  }
  .rs-picker-daterange .rs-picker-toggle-clean {
    right: 32px !important;
  }
`;

export const StyledRadioGroup = styled(RadioGroup)`
  .rs-radio-checker {
    min-height: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .rs-radio-checker label {
    text-transform: none;
  }

  .rs-radio-checker .rs-radio-wrapper {
    top: 3px;
  }
`;

export const StyledRow = styled(Row)`
  background-color: #f5f5f5;
  border-radius: 7px;
  height: 'auto';
  padding: 15px;
  margin-bottom: 10px;

  .rs-col {
    line-height: 20px;
    font-size: 13px;
  }
`;

export const PresetsPanel = styled(Panel)`
  margin-bottom: 20px;
  & > .rs-panel-heading {
    padding: 0;
  }
`;

export const PresetsPanelHeader = styled.h5`
  padding: 20px;
  color: #1675e0;
`;
